import type { ErrorMessageTypes } from '../components/alerts/errors/error-map';

/**
 * A failed account operation, carrying the mapped error code and the server's
 * own wording as separate properties so telemetry keeps both.
 */
export class AccountOperationError extends Error {
    constructor(
        readonly code: ErrorMessageTypes | undefined,
        readonly detail: string | undefined,
        fallback: string
    ) {
        super([code ?? fallback, detail].filter(Boolean).join(': '));
        this.name = 'AccountOperationError';
    }
}
